<template>
  <div>
    <div>
      <h1>Sign Up</h1>
    </div>
    <div>
      <form>
        First name:<br />
        <input type="text" v-model="user.firstName" name="firstname" dense />
        <br />
        Last name:<br />
        <input type="text" v-model="user.lastName" name="lastname" dense />
        <br />
        Email:<br />
        <input type="text" v-model="user.email" name="email" dense />
        <br />
        Password:<br />
        <input type="text" v-model="user.password" name="password" dense />
        <br />
        <input @click.stop="signup" type="button" value="Submit" />
      </form>
    </div>
  </div>
</template>

<script>
import User from "@/classes/user";

export default {
  name: "SignUp",
  data() {
    return {
      user: {
        firstName: null,
        lastName: null,
        email: null,
        password: null
      }
    };
  },
  methods: {
    signup() {
      const { user } = this;
      User.signup(user)
        .then(() => {
          this.$router.push({ name: "Dashboard" });
        })
        .catch(() => {
          // console.error(error);
          // handle error somehow
        });
    }
  }
};
</script>
